// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__2Ydbm","overlay":"Loader_overlay__VXtqf","ripple":"Loader_ripple__3xLHW"};